import React from 'react'
import classNames from 'classnames'
import styles from './SelectSorting.module.scss'

const SelectSorting = ({
  type = 'outline',
  style = {},
  iconPosition = 'right',
  fontSize = 'small',
  value,
  onChange,
  options,
  color = 'primary',
  id = 'select',
  onBlur = () => {},
}) => {
  return (
    <span>
      <select
        id={id}
        value={value}
        onChange={onChange}
        className={classNames(
          styles[type],
          styles[`direction-${iconPosition}`],
          styles[`font-${fontSize}`],
          {
            [styles[`${color}Background`]]: type === 'filled',
            [styles[`${color}Border`]]: type === 'outline',
            [styles.paddingButton]: iconPosition,
          }
        )}
        style={style}
        onBlur={onBlur}
      >
        {options.map((option, index) => (
          <option key={index.toString()} value={option.value}>
            {option.name}
          </option>
        ))}
      </select>
    </span>
  )
}

export default React.memo(SelectSorting)
